module.exports = "<p>\r\n  information works!\r\n</p>\r\n"